import { render, staticRenderFns } from "./FormRubro.vue?vue&type=template&id=9365a15c&scoped=true&"
import script from "./FormRubro.vue?vue&type=script&lang=js&"
export * from "./FormRubro.vue?vue&type=script&lang=js&"
import style0 from "./FormRubro.vue?vue&type=style&index=0&id=9365a15c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9365a15c",
  null
  
)

export default component.exports